import React, { useState, useEffect } from 'react';
import { FiMenu } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header = ({ onToggleSidebar }) => {
  const { currentUser } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <header className="app-header">
      {isMobile && (
        <button 
          className="mobile-menu-toggle"
          onClick={onToggleSidebar}
          aria-label="Toggle menu"
        >
          <FiMenu />
        </button>
      )}
      
      <div className="header-content">
        {/* Contenido del header original */}
        <div className="user-info">
          {currentUser && (
            <span className="user-name">{currentUser.name}</span>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;